const { Fragment, useState, useRef, useEffect } = wp.element;
const { PanelBody, PanelRow, Button, __experimentalNumberControl: NumberControl, TextControl, FormToggle, SelectControl, TextareaControl, ButtonGroup, __experimentalUnitControl: UnitControl } = wp.components;
const { __ } = wp.i18n;

import BColor from "../../BColor";
import BMediaUpload from "../../BMediaUpload";
import BRangeControl from "../../BRangeControl";

const Overlay = ({ attributes, setAttributes }) => {
  const { ODFS, overlay, overlayType, overlayText, overlayLogo, overlayLink, overlayFontSize, overlayTextColor, overlayTextHoverColor, ODFFT, ODFF, ODFST } = attributes;

  return (
    <PanelBody title={__("Overlay", "h5vp")} initialOpen={false}>
      <PanelRow>
        <label className="label" htmlFor="overlay">
          {__("Overlay", "h5vp")}
        </label>
        <FormToggle id="overlay" checked={overlay} onChange={() => setAttributes({ overlay: !overlay })} />
      </PanelRow>
      {overlay && (
        <Fragment>
          <PanelRow>
            <label className="label" htmlFor="overlayTypeText">
              {__("Overlay Type Text", "h5vp")}
            </label>
            <FormToggle id="overlayTypeText" checked={overlayType} onChange={() => setAttributes({ overlayType: !overlayType })} />
          </PanelRow>
          <PanelRow>
            <label className="label" htmlFor="overlayTypeLogo">
              {__("Overlay Type Logo", "h5vp")}
            </label>
            <FormToggle id="overlayTypeLogo" checked={!overlayType} onChange={() => setAttributes({ overlayType: !overlayType })} />
          </PanelRow>
          {overlayType && (
            <Fragment>
              <PanelRow>
                <label htmlFor="" className="label display-block">
                  {__("Overlay Text", "h5vp")}
                </label>
              </PanelRow>
              <PanelRow className="width-100">
                <TextControl value={overlayText} onChange={(overlayText) => setAttributes({ overlayText })} />
              </PanelRow>
            </Fragment>
          )}
          {!overlayType && <BMediaUpload type={["image/jpeg"]} onSelect={(overlayLogo) => setAttributes({ overlayLogo })} value={overlayLogo} />}
          <PanelRow>
            <label htmlFor="" className="label display-block">
              {__("Overlay Link", "h5vp")}
            </label>
          </PanelRow>
          <PanelRow className="width-100">
            <TextControl value={overlayLink} onChange={(overlayLink) => setAttributes({ overlayLink })} />
          </PanelRow>
          {overlayType && (
            <Fragment>
              <BRangeControl label={__("Font Size", "h5vp")} enable={{ eDevice: false }} value={overlayFontSize.number} unit={overlayFontSize.unit} max={500} onChange={(number) => setAttributes({ overlayFontSize: { ...overlayFontSize, number } })} onChangeUnit={(unit) => setAttributes({ overlayFontSize: { number: 0, unit } })} />
              <PanelRow>
                <label htmlFor="" className="label display-block">
                  {__("Overlay Text Color", "h5vp")}
                </label>
                <BColor defaultColor="#ffffff" value={overlayTextColor} onChange={(c) => setAttributes({ overlayTextColor: c })} />
              </PanelRow>
              <PanelRow>
                <label htmlFor="" className="label display-block">
                  {__("Overlay Text Hover Color", "h5vp")}
                </label>
                <BColor defaultColor="#ffffff" value={overlayTextHoverColor} onChange={(c) => setAttributes({ overlayTextHoverColor: c })} />
              </PanelRow>
            </Fragment>
          )}
          <PanelRow className="inline">
            <label htmlFor="" className="label">
              {__("Distance From")}
            </label>
            <SelectControl
              value={ODFFT}
              options={[
                { label: "Top", value: "top" },
                { label: "Bottom", value: "bottom" },
              ]}
              onChange={(ODFFT) => {
                setAttributes({ ODFFT });
              }}
            />
          </PanelRow>
          <BRangeControl label={__("Distance", "h5vp")} enable={{ eDevice: false }} value={ODFF.number} unit={ODFF.unit} max={500} onChange={(number) => setAttributes({ ODFF: { ...ODFF, number } })} onChangeUnit={(unit) => setAttributes({ ODFF: { number: 0, unit } })} />
          <PanelRow className="inline">
            <label htmlFor="" className="label">
              {__("Distance From")}
            </label>
            <SelectControl
              value={ODFST}
              options={[
                { label: "Left", value: "left" },
                { label: "Right", value: "right" },
              ]}
              onChange={(ODFST) => {
                setAttributes({ ODFST });
              }}
            />
          </PanelRow>
          <BRangeControl label={__("Distance", "h5vp")} enable={{ eDevice: false }} value={ODFS.number} unit={ODFS.unit} max={500} onChange={(number) => setAttributes({ ODFS: { ...ODFS, number } })} onChangeUnit={(unit) => setAttributes({ ODFS: { number: 0, unit } })} />
        </Fragment>
      )}
    </PanelBody>
  );
};

export default Overlay;
